'use strict';
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dConversion from "./scala.-Conversion.js";
var $p;
/** @constructor */
function $c_Lio_github_nguyenyou_webawesome_laminar_WebComponent$toL$() {
}
export { $c_Lio_github_nguyenyou_webawesome_laminar_WebComponent$toL$ as $c_Lio_github_nguyenyou_webawesome_laminar_WebComponent$toL$ };
$p = $c_Lio_github_nguyenyou_webawesome_laminar_WebComponent$toL$.prototype = new $j_scala$002e$002dConversion.$h_s_Conversion();
$p.constructor = $c_Lio_github_nguyenyou_webawesome_laminar_WebComponent$toL$;
/** @constructor */
function $h_Lio_github_nguyenyou_webawesome_laminar_WebComponent$toL$() {
}
export { $h_Lio_github_nguyenyou_webawesome_laminar_WebComponent$toL$ as $h_Lio_github_nguyenyou_webawesome_laminar_WebComponent$toL$ };
$h_Lio_github_nguyenyou_webawesome_laminar_WebComponent$toL$.prototype = $p;
$p.j = (function(x) {
  return $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d;
});
var $d_Lio_github_nguyenyou_webawesome_laminar_WebComponent$toL$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_nguyenyou_webawesome_laminar_WebComponent$toL$, "io.github.nguyenyou.webawesome.laminar.WebComponent$toL$", ({
  jV: 1,
  rv: 1,
  o: 1
}));
export { $d_Lio_github_nguyenyou_webawesome_laminar_WebComponent$toL$ as $d_Lio_github_nguyenyou_webawesome_laminar_WebComponent$toL$ };
